import { render } from "./exceptionalArticlesFileUploadList.vue?vue&type=template&id=6fb5feb2"
import script from "./exceptionalArticlesFileUploadList.vue?vue&type=script&lang=js"
export * from "./exceptionalArticlesFileUploadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__